
// Mobile search toggle - the button in static-header.liquid has an inline onclick
// that toggles .live-search visibility. No additional JS needed here.

// Pulsing animation now handled by theme.liquid - this section disabled

/* Slick carousel init — wrapped in try/catch because the slick plugin
   may not be loaded on every page (e.g. product pages). An uncaught error
   here would kill ALL subsequent JS in this file. */
try {
  jQuery(".custom_popup_video").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: false,
    autoplaySpeed: 800,
    dots: false,
    prevArrow:
      '<button class="slide-arrow prev-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><i class="fa-solid fa-chevron-right"></i></button>',
    arrows: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
} catch(e) { /* slick not loaded on this page — safe to ignore */ }

jQuery(document).ready(function () {
  $("div.card-info").on("click", function (e) {
    $("body").addClass("popup_class_add");
    e.stopPropagation();
  });

  $("div#video-container, span#close-button").on("click", function (e) {
    $("body").removeClass("popup_class_add");
    e.stopPropagation();
  });
});

/* Video popup code wrapped in IIFE to prevent "const" collision.
   An inline script elsewhere on the page also declares "const cardInfoElements",
   and duplicate top-level const declarations cause a fatal SyntaxError that
   kills the entire file. Wrapping in IIFE scopes the variables safely. */
(function() {
  // Get elements
  var cardInfoElements = document.querySelectorAll(".card-info");
  var videoPopup = document.getElementById("video-popup");
  var videoContainer = document.getElementById("video-container");

  if (!cardInfoElements.length || !videoPopup || !videoContainer) return;

  // Add event listeners to open and close the popup for each card
  cardInfoElements.forEach(function(cardInfo) {
    cardInfo.addEventListener("click", openVideoPopup);
  });

  videoPopup.addEventListener("click", closeVideoPopup);

  // Function to open the video popup
  function openVideoPopup(event) {
    var videoUrl = event.currentTarget.getAttribute("data-video");

    // Create the video element
    var video = document.createElement("video");
    video.src = videoUrl;
    video.controls = true;

    // Create the close button
    var closeButton = document.createElement("span");
    closeButton.innerHTML = "&times;";
    closeButton.id = "close-button";
    closeButton.addEventListener("click", closeVideoPopup);

    // Append the video and close button to the video container
    videoContainer.innerHTML = "";
    videoContainer.appendChild(video);
    videoContainer.appendChild(closeButton);

    // Show the video popup
    videoPopup.style.display = "block";
  }

  // Function to close the video popup
  function closeVideoPopup() {
    videoPopup.style.display = "none";
  }
})();





jQuery(document).ready(function () {
  console.log('Script loaded and DOM ready');

  $(document).on('click', 'button.needsclick.klaviyo-close-form svg', function () {
    console.log('SVG inside close button clicked');
    $('.needsclick.kl-private-reset-css-Xuajs1').css('display', 'none');
  });
});

/* =====================================================
   PAYMENT TERMS RELOCATION (Desktop >992px only)
   Moves the "pay in installments" text from the price block
   to below the Shop Pay button.

   Flow:
   1. Empire.js PaymentTerms class moves <shopify-payment-terms>
      from [data-payment-terms-reference] into [data-payment-terms-target]
      (which sits in the price block).
   2. Our CSS hides [data-payment-terms-target] inside .product-block--price.
   3. This JS waits for empire.js to finish, then physically moves
      [data-payment-terms-target] to after .shopify-payment-button.
   4. Adds class .wolden-payment-terms-relocated which CSS shows as visible.
   ===================================================== */
(function() {
  if (window.innerWidth <= 992) return; // mobile: leave in original spot

  function movePaymentTerms() {
    // Find the payment terms target form (empire.js populates it)
    var terms = document.querySelector('[data-payment-terms-target]');
    var shopPayBtn = document.querySelector('.shopify-payment-button');

    if (!terms || !shopPayBtn) return false;

    // Check if empire.js has moved the shopify-payment-terms element into the target
    var paymentTermsEl = terms.querySelector('shopify-payment-terms');
    if (!paymentTermsEl) return false;

    /* Insert payment terms BETWEEN Shop Pay button and "More payment options" link.
       The proxy setup code should have already moved more-payment-options-link
       into .shopify-payment-button by now. We look for it there. */
    var moreOptions = shopPayBtn.querySelector('more-payment-options-link');
    if (moreOptions) {
      shopPayBtn.insertBefore(terms, moreOptions);
    } else {
      shopPayBtn.appendChild(terms);
    }

    // Force visibility and add our styling class
    terms.setAttribute('style', 'display: block !important; margin-top: 6px; text-align: center;');
    terms.classList.add('wolden-payment-terms-relocated');

    console.log('[Wolden] Payment terms relocated below Shop Pay');
    return true;
  }

  // Poll: empire.js + Shopify payment terms load asynchronously
  // Try every 300ms for up to 8 seconds (accounts for slow connections)
  var attempts = 0;
  var maxAttempts = 27;
  var interval = setInterval(function() {
    if (movePaymentTerms() || ++attempts >= maxAttempts) {
      clearInterval(interval);
      if (attempts >= maxAttempts) {
        console.log('[Wolden] Payment terms relocation: element not found after timeout');
      }
    }
  }, 300);
})();

/* =====================================================
   SHOP PAY BUTTON — OPACITY PROXY (Item 5)
   The Shop Pay button uses a closed Shadow DOM inside
   <shopify-accelerated-checkout>, so we can't style it via CSS/JS.

   Strategy: "Opacity Proxy"
   - The REAL Shop Pay button sits ON TOP (z-index: 2, opacity: 0.001)
     → invisible but captures all clicks natively (no CORS issues)
   - A VISUAL proxy button sits BELOW (z-index: 1)
     → white background, purple border, "Buy with Shop Pay" text
   - Container has position: relative and a fixed height

   ⚠️ GRACEFUL DEGRADATION: If Shopify changes the structure, the real
   purple button just shows through (opacity stays 1 if JS fails).
   Customers can still check out — they just see the default purple.
   ===================================================== */
(function() {
  function setupShopPayProxy() {
    /* The actual DOM structure (no .shopify-payment-button__button wrapper):
       .shopify-payment-button
         └── shopify-accelerated-checkout  (86px: 48px button + "More payment options" link)
             ├── shop-pay-wallet-button    (slot="button", inside closed Shadow DOM)
             └── more-payment-options-link (slot="more-options")
         └── small#shopify-buyer-consent   (hidden)
    */
    var container = document.querySelector('.shopify-payment-button');
    if (!container) return false;

    var acceleratedCheckout = container.querySelector('shopify-accelerated-checkout');
    if (!acceleratedCheckout) return false;

    /* Don't setup twice */
    if (document.getElementById('wolden-shoppay-proxy')) return true;

    /* Wait for the button to have rendered height (not 0) */
    var totalHeight = acceleratedCheckout.offsetHeight;
    if (totalHeight < 10) return false; /* Not rendered yet */

    /* Read the button height from Shopify's CSS variable (typically 48px) */
    var btnHeight = getComputedStyle(acceleratedCheckout)
      .getPropertyValue('--shopify-accelerated-checkout-button-block-size') || '48px';
    var btnHeightNum = parseInt(btnHeight, 10) || 48;

    /* --- Set up .shopify-payment-button as positioning context --- */
    container.style.position = 'relative';

    /* --- Make the REAL accelerated-checkout invisible but on top --- */
    /* It stays position:relative so it keeps its layout space.
       We clip it to only show the button area (top btnHeightNum px) so that
       the invisible clickable area doesn't extend beyond the proxy button. */
    acceleratedCheckout.style.position = 'relative';
    acceleratedCheckout.style.zIndex = '2';
    acceleratedCheckout.style.opacity = '0.001';
    /* Clip to button height so "More payment options" area doesn't block below */
    acceleratedCheckout.style.height = btnHeightNum + 'px';
    acceleratedCheckout.style.overflow = 'hidden';

    /* --- Move "More payment options" link OUT of the invisible element --- */
    /* It's a light-DOM child of <shopify-accelerated-checkout>, slotted via
       slot="more-options". Moving it to container keeps it visible and clickable. */
    var moreOptionsLink = acceleratedCheckout.querySelector('more-payment-options-link');
    if (moreOptionsLink) {
      moreOptionsLink.style.display = 'block';
      moreOptionsLink.style.textAlign = 'center';
      moreOptionsLink.style.marginTop = '-2px'; /* Tight gap between payment terms and this link */
      container.appendChild(moreOptionsLink);
    }

    /* --- Move payment terms BETWEEN Shop Pay and "More payment options" --- */
    /* Desktop only (>992px): on mobile, payment terms stay in the price block.
       We do this here (inside proxy setup) to guarantee correct ordering,
       since the separate payment-terms IIFE can't be sure moreOptionsLink
       has been moved yet. Order: [proxy] → [payment terms] → [more options] */
    if (window.innerWidth > 992) {
      var terms = document.querySelector('[data-payment-terms-target]');
      if (terms && terms.querySelector('shopify-payment-terms')) {
        if (moreOptionsLink) {
          container.insertBefore(terms, moreOptionsLink);
        } else {
          container.appendChild(terms);
        }
        terms.setAttribute('style', 'display: block !important; margin-top: 6px; text-align: center;');
        terms.classList.add('wolden-payment-terms-relocated');
        console.log('[Wolden] Payment terms relocated (via proxy setup)');
      }
    }

    /* --- Create VISUAL proxy button below (z-index: 1) --- */
    var proxy = document.createElement('div');
    proxy.id = 'wolden-shoppay-proxy';
    proxy.style.cssText = [
      'position: absolute',
      'top: 0',
      'left: 0',
      'right: 0',
      'height: ' + btnHeightNum + 'px',
      'background: white',
      'border: 2px solid #5A31F4',
      'border-radius: 32px',
      'display: flex',
      'align-items: center',
      'justify-content: center',
      'z-index: 1',
      'pointer-events: none',
      'box-sizing: border-box',
      'transition: background-color 0.2s ease'
    ].join(' !important;') + ' !important;';

    /* "Buy with [Shop Pay logo]" using the OFFICIAL Shop Pay wordmark SVG
       (extracted from Shopify's closed Shadow DOM, fill changed from #fff to #5A31F4
       since our proxy has a white background instead of the original purple) */
    proxy.innerHTML = '<span style="color: #5A31F4; font-family: -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial, sans-serif; font-size: 16px; font-weight: 500; line-height: 1.2; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; display: flex; align-items: center; gap: 6px; pointer-events: none;">' +
      'Buy with ' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="61" height="24" viewBox="0 -2 206 81" fill="none">' +
        '<path fill="#5A31F4" d="M29.514 35.18c-7.934-1.697-11.469-2.36-11.469-5.374 0-2.834 2.392-4.246 7.176-4.246 4.207 0 7.283 1.813 9.546 5.363.171.274.524.369.812.222l8.927-4.447a.616.616 0 0 0 .256-.864c-3.705-6.332-10.55-9.798-19.562-9.798-11.843 0-19.2 5.752-19.2 14.898 0 9.714 8.96 12.169 16.904 13.865 7.944 1.697 11.49 2.36 11.49 5.373 0 3.014-2.584 4.436-7.742 4.436-4.763 0-8.297-2.15-10.433-6.321a.63.63 0 0 0-.843-.274L6.47 52.364a.623.623 0 0 0-.278.843c3.535 7.006 10.785 10.947 20.47 10.947 12.334 0 19.787-5.658 19.787-15.088s-9.001-12.169-16.935-13.865v-.021ZM77.353 16.036c-5.062 0-9.536 1.77-12.75 4.92-.203.19-.534.053-.534-.221V.622a.62.62 0 0 0-.63-.622h-11.17a.62.62 0 0 0-.63.622v62.426a.62.62 0 0 0 .63.621h11.17a.62.62 0 0 0 .63-.621V35.664c0-5.289 4.11-9.345 9.653-9.345 5.542 0 9.557 3.972 9.557 9.345v27.384a.62.62 0 0 0 .63.621h11.17a.62.62 0 0 0 .63-.621V35.664c0-11.505-7.646-19.618-18.356-19.618v-.01ZM118.389 14.255c-6.065 0-11.767 1.823-15.847 4.467a.618.618 0 0 0-.202.833l4.922 8.292c.182.295.566.4.865.22a19.82 19.82 0 0 1 10.262-2.78c9.749 0 16.914 6.785 16.914 15.75 0 7.64-5.734 13.297-13.006 13.297-5.926 0-10.037-3.403-10.037-8.207 0-2.75 1.185-5.005 4.271-6.596a.607.607 0 0 0 .246-.864l-4.645-7.754a.632.632 0 0 0-.759-.264c-6.225 2.276-10.593 7.755-10.593 15.109 0 11.126 8.981 19.428 21.507 19.428 14.629 0 25.147-9.998 25.147-24.338 0-15.372-12.237-26.603-29.066-26.603l.021.01ZM180.098 15.951c-5.649 0-10.689 2.055-14.373 5.68a.313.313 0 0 1-.534-.222v-4.362a.62.62 0 0 0-.63-.621H153.68a.62.62 0 0 0-.63.621v62.331a.62.62 0 0 0 .63.622h11.169a.62.62 0 0 0 .631-.622v-20.44c0-.274.331-.41.533-.231 3.674 3.371 8.532 5.342 14.096 5.342 13.102 0 23.321-10.463 23.321-24.054 0-13.592-10.23-24.054-23.321-24.054l-.011.01Zm-2.103 37.54c-7.454 0-13.103-5.847-13.103-13.58 0-7.734 5.638-13.582 13.103-13.582 7.464 0 13.091 5.753 13.091 13.581 0 7.829-5.553 13.581-13.102 13.581h.011Z"></path>' +
      '</svg>' +
      ' w/o Customizing</span>';

    /* Hover effect — listen on the container (proxy has pointer-events: none,
       and the real button is transparent so hover needs to come from the parent) */
    container.addEventListener('mouseenter', function() {
      proxy.style.backgroundColor = '#F8F5FF';
    });
    container.addEventListener('mouseleave', function() {
      proxy.style.backgroundColor = 'white';
    });

    /* Insert proxy as first child of container — below the real button in z-stack */
    container.insertBefore(proxy, container.firstChild);

    console.log('[Wolden] Shop Pay opacity proxy created (button height: ' + btnHeightNum + 'px)');
    return true;
  }

  /* Poll: Shop Pay renders asynchronously
     Try every 400ms for up to 10 seconds */
  var attempts = 0;
  var maxAttempts = 25;
  var interval = setInterval(function() {
    if (setupShopPayProxy() || ++attempts >= maxAttempts) {
      clearInterval(interval);
      if (attempts >= maxAttempts) {
        console.log('[Wolden] Shop Pay proxy: timed out — default purple button will show');
      }
    }
  }, 400);
})();

/* ==========================================================================
   KLAVIYO SCROLL-LOCK FIX
   ==========================================================================
   Bug: Klaviyo's "Spin It to Win It" popup adds the class
   "klaviyo-prevent-body-scrolling" to <body>, which applies
   overflow: hidden !important. When the popup is dismissed, Klaviyo
   fails to remove this class, leaving the page permanently unscrollable
   until refresh.

   Fix: Watch for Klaviyo's form container becoming hidden (display:none)
   while the scroll-lock class is still on the body. When detected,
   remove the class to restore scrolling.
   ========================================================================== */
(function() {
  'use strict';

  var LOCK_CLASS = 'klaviyo-prevent-body-scrolling';
  var cleaned = false;

  function isKlaviyoFormVisible() {
    var forms = document.querySelectorAll('.klaviyo-form');
    var anyVisible = false;
    forms.forEach(function(form) {
      if (form.offsetWidth > 0 && form.offsetHeight > 0) {
        anyVisible = true;
      }
    });
    return anyVisible;
  }

  function cleanupIfNeeded() {
    if (cleaned) return;
    if (document.body.classList.contains(LOCK_CLASS) && !isKlaviyoFormVisible()) {
      document.body.classList.remove(LOCK_CLASS);
      cleaned = true;
      console.log('[Wolden] Removed Klaviyo scroll-lock — popup dismissed but class was stuck');
    }
  }

  /* Strategy 1: Watch <body> class changes.
     Klaviyo re-sets the class on dismiss (sets it again rather than removing),
     so the MutationObserver fires and we can check if the form is still visible. */
  var bodyObserver = new MutationObserver(function() {
    cleanupIfNeeded();
  });

  /* Strategy 2: Watch the entire document for DOM changes.
     When Klaviyo hides its form (style change, display:none), we detect it.
     We use subtree + attributes to catch style changes on Klaviyo's elements. */
  var domObserver = new MutationObserver(function(mutations) {
    /* Only check if we still have the lock class and haven't cleaned up yet */
    if (cleaned || !document.body.classList.contains(LOCK_CLASS)) return;

    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      /* Check if the mutation is on or inside a Klaviyo element */
      if (target.className && typeof target.className === 'string' &&
          (target.className.indexOf('klaviyo') !== -1 ||
           (target.closest && target.closest('[class*="klaviyo"]')))) {
        cleanupIfNeeded();
        return;
      }
    }
  });

  function startObserving() {
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    domObserver.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'], subtree: true });
  }

  if (document.body) {
    startObserving();
  } else {
    document.addEventListener('DOMContentLoaded', startObserving);
  }
})();

/* =====================================================
   PULSE ANIMATION — CUSTOMIZE BUTTONS
   =====================================================
   Appends a pulse overlay <span> to the desktop and mobile
   "Customize With Your Pet's Photo" buttons, replicating
   the homepage's expanding-ring pulsate effect.

   The CSS (@keyframes wolden-btn-pulse + .wolden-btn-pulse-effect)
   lives in custom-new.css. This JS just injects the span elements.
   ===================================================== */
(function() {
  function addPulseToButtons() {
    var selectors = ['.wolden-swap-desktop__btn', '.wolden-swap-mobile-info__btn', '.wolden-swap-gallery a'];
    selectors.forEach(function(sel) {
      var btn = document.querySelector(sel);
      if (btn && !btn.querySelector('.wolden-btn-pulse-effect')) {
        var pulse = document.createElement('span');
        pulse.className = 'wolden-btn-pulse-effect';
        btn.appendChild(pulse);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addPulseToButtons);
  } else {
    addPulseToButtons();
  }
})();



// ─────────────────────────────────────────────────────────────────────────────
// DIY Frame cart invariant enforcement
//
// The DIY Frame (variant 43443436781670) is an add-on that must only exist in
// the cart alongside a "Your Custom Pet Art Kit" line item. If a customer adds
// kit + frame via the Bubble cart, then removes the kit from Shopify's cart
// drawer, we must remove the orphan frame too — otherwise they check out with
// a standalone frame, which we don't sell.
//
// This monkey-patches fetch and XHR to re-evaluate cart state after any
// /cart/{add,change,update,clear}.js call, and silently removes the frame if
// no valid kit is present. Also runs once on page load to catch stale carts.
// ─────────────────────────────────────────────────────────────────────────────
(function() {
  'use strict';

  var FRAME_VARIANT_ID = 43443436781670;
  var FRAME_PRODUCT_ID = 7759950151782;
  var KIT_TITLE_MATCH  = 'Custom Pet Art Kit'; // substring match on product_title
  var TOAST_MSG        = 'Frame removed \u2014 requires a Paint by Numbers kit';

  var _enforcing = false;

  function isValidKit(item) {
    if (!item || item.product_id === FRAME_PRODUCT_ID) return false;
    var t = (item.product_title || item.title || '');
    return t.indexOf(KIT_TITLE_MATCH) !== -1;
  }

  function showToast(msg) {
    if (!document.body) return;
    var t = document.createElement('div');
    t.textContent = msg;
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.style.cssText = [
      'position:fixed','left:50%','bottom:28px','transform:translateX(-50%)',
      'background:#4a1a1a','color:#fff','padding:12px 20px','border-radius:8px',
      'font:500 14px/1.4 system-ui,-apple-system,Segoe UI,Roboto,sans-serif',
      'box-shadow:0 6px 20px rgba(0,0,0,.18)','z-index:2147483647',
      'max-width:90vw','opacity:0','transition:opacity 200ms ease','pointer-events:none'
    ].join(';');
    document.body.appendChild(t);
    requestAnimationFrame(function() { t.style.opacity = '1'; });
    setTimeout(function() {
      t.style.opacity = '0';
      setTimeout(function() { if (t.parentNode) t.parentNode.removeChild(t); }, 250);
    }, 4000);
  }

  function enforceCartInvariant() {
    if (_enforcing) return;
    _enforcing = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var hasFrame = (cart.items || []).some(function(i) { return i.variant_id === FRAME_VARIANT_ID; });
        if (!hasFrame) return null;
        var hasKit = (cart.items || []).some(isValidKit);
        if (hasKit) return null;
        // Orphan frame — remove it
        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: FRAME_VARIANT_ID, quantity: 0 })
        }).then(function() {
          showToast(TOAST_MSG);
          // Refresh the cart UI. Empire theme and most drawers listen for these.
          try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
          try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
          try { window.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
          // If we're on the cart page itself, hard-reload to show the updated cart
          // after a short delay so the toast is visible before navigation.
          if (window.location.pathname === '/cart') {
            setTimeout(function() { window.location.reload(); }, 1200);
          }
        });
      })
      .catch(function(e) { console.warn('[DIY Frame guard]', e); })
      .then(function() { _enforcing = false; }, function() { _enforcing = false; });
  }

  var CART_RE = /\/cart\/(add|change|update|clear)\.js/;

  // Intercept fetch
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function(input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (CART_RE.test(url)) {
        p.then(function() { setTimeout(enforceCartInvariant, 60); }, function() {});
      }
      return p;
    };
  }

  // Intercept XHR (some theme code and apps use XHR)
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.__diyframe_url = url || '';
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    if (this.__diyframe_url && CART_RE.test(this.__diyframe_url)) {
      this.addEventListener('load', function() { setTimeout(enforceCartInvariant, 60); });
    }
    return origSend.apply(this, arguments);
  };

  // Initial pass on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceCartInvariant);
  } else {
    enforceCartInvariant();
  }
})();

